module.exports = __webpack_public_path__ + "img/wm2026_en.f83079dd.png";